import React from 'react';

import {
    AppLayout, Tabs
} from 'AWS-UI-Components-React';

import {
    TaskTable
} from './tables/task_table'
import {Custom} from "./custom";
import {Reports} from "./reports";

import Navigation from './navigation'
const tabs = [
    {
        "label": "Recent Tasks",
        "id": "first",
        "content": <TaskTable type={"recent"}/>
    },
    {
        "label": "Yesterday",
        "id": "second",
        "content": <TaskTable type={"yesterday"}/>
    },
    {
        "label": "Custom",
        "id": "third",
        "content": <Custom/>
    }
];
const Content = () => (
    <div className='awsui-grid awsui-util-p-s'>
        <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
            <div className='col-xxs-12'>
                <div className='awsui-row'>
                    <div
                        className='custom-home__header-title col-xxs-10 offset-xxs-1 col-s-10 col-l-11 offset-l-1 col-xl-10'>
                        <div className='awsui-text-large'>
                            <div><strong>Activities</strong></div>
                        </div>

                        <div className='beersTable'>
                            <Tabs tabs={tabs} activeTabId="first"></Tabs>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
);

export class Main extends React.Component {

    render() {
        return (
            <div className="awsui">
                <AppLayout
                    className='awsui-util-no-gutters'
                    content={<Content/>}
                    navigation={<Navigation activeHref="#/"/>}
                    navigationOpen={true}
                    toolsHide={false}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/main.jsx